export default __webpack_public_path__ + "static/media/jaguarLandRover.505e28b4.gif";